<template>
    <NuxtLink
        to="/cart"
        class="group relative ml-6 flex items-center"
        :aria-label="$snippets['headless.header.toCart']">
        <ShoppingBag class="size-5! stroke-2 duration-300 hover:text-green-500 lg:size-6!" />
        <span class="count-label" v-if="cartCount > 0">{{ cartCount }}</span>
    </NuxtLink>
</template>

<script setup lang="ts">

    import ShoppingBag from '~/components/icon/ShoppingBag.vue';

    const { count: cartCount } = useCart();
</script>
